import { render } from "./peihuannewVipRecharge.vue?vue&type=template&id=22bd8d4b&scoped=true&ts=true"
import script from "./peihuannewVipRecharge.vue?vue&type=script&lang=ts"
export * from "./peihuannewVipRecharge.vue?vue&type=script&lang=ts"

import "./peihuannewVipRecharge.vue?vue&type=style&index=0&id=22bd8d4b&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bd8d4b"]])

export default __exports__